import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  ModalHeader,
  Text,
} from '@alexpireddu/map-ui';
import { useState, FC, useCallback } from 'react';
import { confirmPayment } from '../../actions';
import { VideoTableCampaign } from '../../apis/videoApis';
import { useAction } from '../../hooks';
import { formatCurrency } from '../../utils/currencyHelper';

export interface ConfirmPaymentModalProps {
  campaign: VideoTableCampaign;
  onClose: Function;
  readonly?: boolean;
}

const ConfirmPaymentModal: FC<ConfirmPaymentModalProps> = ({
  onClose,
  campaign,
  readonly = false,
}) => {
  const [isLoading, setLoading] = useState<boolean>(false);
  const confirm = useAction(confirmPayment);

  const handleConfirmPayment = useCallback(() => {
    setLoading(true);
    confirm({
      campaign_id: campaign.id,
    })
      .then(() => {
        setLoading(false);
        onClose(true);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [campaign.id, onClose, confirm]);

  const handleClickOutside = () => {
    if (readonly) {
      onClose();
    }
  };

  return (
    <Modal size="lg" onClickOutside={handleClickOutside}>
      <ModalHeader>
        <ModalCloseButton onClick={() => onClose(false)} />
      </ModalHeader>
      <ModalBody>
        <Text>
          Vuoi confermare di aver ricevuto il pagamento di{' '}
          {formatCurrency(campaign.price)} per la campagna {campaign.name}?
        </Text>
      </ModalBody>
      {!readonly && (
        <ModalFooter>
          <Button
            variant="secondary"
            onClick={() => onClose(false)}
            disabled={isLoading}
          >
            Annulla
          </Button>
          <Button
            variant="primary"
            onClick={handleConfirmPayment}
            disabled={isLoading}
          >
            Conferma
          </Button>
        </ModalFooter>
      )}
    </Modal>
  );
};

export default ConfirmPaymentModal;
